module.exports = __webpack_public_path__ + "img/box.607ce81a.svg";